import React from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import { UTLabel, WithLoading } from '@widergy/energy-ui';

import UTTable from '../../../../../../components/UTTable';
import SecondaryTopbar from '../../../../../../components/SecondaryTopbar';
import UTTouchableWithoutFeedback from '../../../../../../components/UTTouchableWithoutFeedback';
import { tipPropTypes } from '../../../../../../../redux/tipHandlers';
import { tipActiveRowSize, inactiveRowSize } from '../../../../../../../constants/sizes';
import { appConfig } from '../../../../../../../config/customization';
import { message } from '../../../../../../../utils/stringUtils';
import LoaderImg from '../../../../../../assets/spinner.gif';

import FieldDetailContainer from './components/TipDetail';
import ShareLinksDropdown from './components/TipDetail/components/ShareLinksDropdown';
import socialIconStyles from './components/TipDetail/styles';
import stylesJS from './styles';
import styles from './styles.module.scss';

function setDefaultImage(ev) {
  const imgSrc = ev.target.getAttribute('data');
  if (imgSrc) {
    ev.target.setAttribute('data', '');
    ev.target.src = imgSrc;
  }
}

/* eslint-disable react/prop-types */
const imageRender = ({ cellData }) => (
  <img
    src={LoaderImg}
    alt={message('Tips:icon')}
    style={stylesJS.imageIcon}
    data={cellData}
    onLoad={setDefaultImage}
  />
);

/* eslint-enable react/prop-types */

function TipsScene({ tips, placeText, placeIcon, onPressLike }) {
  /* eslint-disable react/prop-types */
  const titleRender = ({ cellData }) => (
    <UTLabel semibold style={stylesJS.title}>
      {cellData}
    </UTLabel>
  );
  /* eslint-enable react/prop-types */

  const columns = [
    { key: 'icon_url', name: '', width: 0.07, cellRenderer: imageRender },
    { key: 'title', name: '', width: 0.7, cellRenderer: titleRender }
  ];

  return (
    <div style={stylesJS.container}>
      <SecondaryTopbar titleText={placeText} titleIcon={placeIcon} style={stylesJS.topbar} />
      <div style={stylesJS.table}>
        {appConfig.energyAdvisor.tipsWithTitle ? (
          <UTTable
            columns={columns}
            rows={tips}
            headerHeight={0}
            openable
            renderActiveRow={(rowData, positionStyle) => (
              <FieldDetailContainer rowData={rowData} style={positionStyle} />
            )}
            activeRowStyle={stylesJS.activeRowStyle}
            rowHeight={(index, activeRowIndex) =>
              index === activeRowIndex ? tipActiveRowSize : inactiveRowSize
            }
            disableHeader
            id={placeText}
            scrolleable
          />
        ) : (
          tips.map(tip => (
            <div key={tip.description} style={stylesJS.tipWithoutTitle}>
              <img
                src={LoaderImg}
                alt={message('Tips:icon')}
                style={stylesJS.imageIcon}
                data={tip.icon_url}
                onLoad={setDefaultImage}
              />
              <UTLabel small className={styles.tipDescription}>
                {tip.description}
              </UTLabel>
              <ShareLinksDropdown rowData={tip} />
              <UTTouchableWithoutFeedback
                onClick={() => onPressLike(tip)}
                style={tip.like ? socialIconStyles.socialIconHeartLiked : socialIconStyles.socialIconHeart}
              />
            </div>
          ))
        )}
      </div>
    </div>
  );
}

TipsScene.propTypes = {
  tips: PropTypes.arrayOf(PropTypes.shape(tipPropTypes)).isRequired,
  placeIcon: PropTypes.string.isRequired,
  placeText: PropTypes.string.isRequired,
  onPressLike: PropTypes.func.isRequired
};

export default WithLoading(props => props.loading)(Radium(TipsScene));
